import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'
import auth from '@/utils/authentication'

import DailyReport from '@/components/pages/DailyReport'
import DailyReportMonth from '@/components/modules/DailyReport/Month'
import DailyReportUser from '@/components/modules/DailyReport/User'
import DailyReportDay from '@/components/modules/DailyReport/Day'

import Settings from '@/components/pages/Settings'
import SettingsMail from '@/components/modules/Settings/SendMail'
import SettingsOrganization from '@/components/modules/Settings/Organization'

import UpdateList from '@/components/pages/UpdateList'
import SignOut from '@/components/pages/SignOut'
import NotFound from '@/components/pages/NotFound'

import store from '@/store/index.js'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: DailyReport,
      children: [
        {
          path: '',
          name: 'default',
          component: DailyReportMonth,
          meta: {requiresAuth: true}
        },
        {
          path: 'month',
          name: 'month',
          component: DailyReportMonth,
          meta: {requiresAuth: true}
        },
        {
          path: 'user',
          name: 'user',
          component: DailyReportUser,
          meta: {requiresAuth: true}
        },
        {
          path: 'day',
          name: 'day',
          component: DailyReportDay,
          meta: {requiresAuth: true}
        }
      ],
      meta: {requiresAuth: true}
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      children: [
        {
          path: 'mail',
          name: 'mail-settings',
          component: SettingsMail,
          meta: {requiresAuth: true}
        },
        {
          path: 'organization',
          name: 'organization-settings',
          component: SettingsOrganization,
          meta: {requiresAuth: true}
        }
      ],
      meta: {requiresAuth: true}
    },
    {
      path: '/updatelist',
      name: 'updatelist',
      component: UpdateList
    },
    {
      path: '/signout',
      name: 'signout',
      component: SignOut
    },
    {
      path: '*',
      name: 'notfound',
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  // サインインが必要なページか確認
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // サインインされていなければsignIn()をコール
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        auth.getRedirectResult()
        //送信先設定のページで編集があった場合、遷移しようとすると確認をする
        if (from.name === 'mail-settings' && to.name !== 'mail-settings' && store.state.hasChanged) {
          Vue.swal({
            icon: 'info',
            html: '保存していない内容が破棄されます。<br>よろしいですか。',
            showCancelButton: true,
            confirmButtonText: 'OK',
            reverseButtons: true,
            allowOutsideClick: false
          }).then((result)=> {
            if(result.isConfirmed) {
              store.commit('setHasChanged', false)
              next()
            }
          })
          return
        }
        next()
      } else if (sessionStorage.getItem('isSignOut') !== 'true') {
        Vue.swal({
          icon: 'info',
          html: '認証情報が必要です。<br>下記ボタンよりサインインを行って下さい',
          confirmButtonText: 'サインイン',
          allowOutsideClick: false
        }).then(() => {
          auth.signIn()
        })
      } else {
        next('/signout')
      }
    })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/plugins/router.js